// extracted by mini-css-extract-plugin
export default {"Services":"Services_Services__fJTQy","ServiceToggler":"Services_ServiceToggler__2j-yp"};